const fbID = "595609378618094";
const fbPageID = "105751340935336";

module.exports = {
  fbID: fbID,
  fbPageID: fbPageID
}